module.exports = __webpack_public_path__ + "static/media/shortText.3e0bd3ed.svg";